import { CNotification } from "components/widget/CNotification";
import { SvgShare } from "icons/SvgShare";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";


export const StatementFooterTable = ({ metrics , trades }: any) => {
    let parms = useParams()
    const [visibleAlert, setVisibleAlert] = useState<boolean>(false)
    const [grossSum, setGrossSum] = useState<number>(0)

    const handelCopyLink = () => {
        navigator.clipboard.writeText(`https://account.tradestars.co/analytics/10/statement`);
        setVisibleAlert(true)
        setTimeout(() => {
            setVisibleAlert(false)
        }, 5000);
    }

    useEffect(() => {
        if (trades) {
            let gross_sum = 0;
            for (let i in trades) {
                if (i != '0') {
                    gross_sum = gross_sum + +trades[i].order_profit
                }
            }
            setGrossSum(gross_sum)
        }
    }, [trades])

    return (
        <>
            <div className="flex flex-col items-center justify-between w-full mt-2 md:flex-row">
                <button onClick={handelCopyLink} className="md:w-fit w-full h-[40px] flex items-center md:mt-0 mt-4 px-2 rounded-md text-white text-sm border-b border-trade-100  bg-trade-50 md:order-1 order-2">
                    <SvgShare className="w-[20px] stroke-white mx-2" />
                    <span>دریافت استیتمنت</span>
                </button>
                <div className="w-full max-w-[390px] text-white text-sm flex flex-col md:order-2 order-1">
                    <div className="flex items-center justify-between w-full">
                        <span>جمع :</span>
                        <span className="px-[8px]">{metrics?.sumOfProfits?.toFixed(2)}</span>
                        <span className="px-[8px]">{metrics?.sumOfCommissions?.toFixed(2)}</span>
                        <span className="px-[8px]">{metrics?.sumOfSwaps?.toFixed(2)}</span>
                    </div>
                    <div className="flex items-center w-full mt-3">
                        <span> جمع ناخالص :</span>
                        <span className="mr-3">{grossSum?.toFixed(2)}</span>
                    </div>
                </div>
            </div>

            <CNotification visible={visibleAlert} isLoading={false} message="آدرس کپی شد" />

        </>
    )
}